import React from "react";
import { BaseControlQuestionProps } from "./type";
import { SingleSelectBoxQuestion as SingleSelectBoxType } from "@shared/types";
import { Question } from "../question";
import { SelectInputBoxOption } from "component-library";
import { ControlledSelectInputBox } from "../form/controlled-select-input-box";
import { useTranslation } from "react-i18next";

export const SingleSelectBoxQuestion: React.FC<
  BaseControlQuestionProps & Omit<SingleSelectBoxType, "type" | "required">
> = ({ position, id, control, question, answer_options, required }) => {
  const { i18n } = useTranslation();

  return (
    <Question
      id={id}
      question={<span>{question[i18n.language]}</span>}
      position={position}
      direction="column"
    >
      <ControlledSelectInputBox
        name={id}
        control={control}
        isMultiSelect={false}
        required={required}
      >
        {Object.values(answer_options).map(({ value, label }) => (
          <SelectInputBoxOption key={value} value={value}>
            {label[i18n.language]}
          </SelectInputBoxOption>
        ))}
      </ControlledSelectInputBox>
    </Question>
  );
};
